const entity = 'clubs'
const entitySingle = 'club'
const tableIcon = 'cil-people'

export {
  entity,
  entitySingle,
  tableIcon
}
